import type { CollabConnectionState } from '@/components/artifacts/detail/ConnectionStateBanner';

export function isCollaborativeEditorEditable(
  canEdit: boolean,
  state: CollabConnectionState
): boolean {
  return canEdit && state === 'connected';
}
